<div class="page-wrapper">
  <img
    class="page-background-image"
    ngSrc="assets/airport-bg.webp"
    alt="Airport background"
    fill
    priority
    fetchpriority="high"
  />
  <div class="background-overlay"></div>

  <div class="selection-container">
    @if (!isLoading()) {
    <div
      [class]="!isNoLocationAssigned() && accessiblePlatforms().length > 0 ? 'glass-box' : 'glass-box-no-access'"
    >
      @if (isNoLocationAssigned()) {
      <div class="no-access-container no-location-state">
        <div class="no-location-icon-wrap" aria-hidden="true">
          <img
            src="assets/icons/platform-select/no-location.svg"
            class="no-location-icon"
            alt=""
          />
        </div>
        <span class="no-access-title">{{ 'platformSelector.noLocationTitle' | translate }}</span>
        <p class="no-access-message">
          {{ 'platformSelector.noLocationDescription' | translate }}
        </p>
        <div class="no-access-action">
          <p-button [label]="'platformSelector.logoutLabel' | translate" (click)="onLogout()"
            styleClass="no-location-logout-btn"></p-button>
        </div>
      </div>
      } @else if (accessiblePlatforms().length > 0) {
      <div class="header">
        <h2>{{ 'platformSelector.title' | translate }}</h2>
      </div>

      <div class="platform-grid">
        @for (platform of accessiblePlatforms(); track platform.id) {
        <div class="platform-card" [class]="'platform-' + platform.id.toLowerCase()" (click)="selectPlatform(platform)">
          <div class="card-icon">
            <img [src]="platform.icon" alt="Platform Icon" />
          </div>
          <div class="card-content">
            <h3>{{ platform.name }}</h3>
            <p>{{ platform.description }}</p>
          </div>
        </div>
        }
      </div>
      } @else {
      <div class="no-access-container">
        <img src="assets/no-access.svg" class="no-access-icon" alt="No Access Icon" />
        <span class="no-access-title"> {{ 'platformSelector.noAccessTitle' | translate }}</span>
        <p class="no-access-message">
          {{ 'platformSelector.noAccessDescription' | translate }}
        </p>
        <div class="no-access-action">
          <p-button [label]="'platformSelector.logoutLabel' | translate" (click)="onLogout()"
            styleClass="no-access-logout-btn"></p-button>
        </div>
      </div>
      }
    </div>
    }
  </div>

  <app-logout-modal [visible]="isLogoutModalVisible()" (confirm)="onLogoutConfirm()"
    (cancel)="onLogoutCancel()"></app-logout-modal>

  @if (isLoading()) {
  <div class="loader-overlay">
    <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
  </div>
  }
</div>